// no baseURI

// object to store loaded chunks
// "1" means "loaded", otherwise not loaded yet
var installedChunks = {
	"app-page": 1
};

// no on chunks loaded

var installChunk = (chunk) => {
	var moreModules = chunk.modules, chunkIds = chunk.ids, runtime = chunk.runtime;
	for(var moduleId in moreModules) {
		if(__webpack_require__.o(moreModules, moduleId)) {
			__webpack_require__.m[moduleId] = moreModules[moduleId];
		}
	}
	if(runtime) runtime(__webpack_require__);
	for(var i = 0; i < chunkIds.length; i++)
		installedChunks[chunkIds[i]] = 1;

};

// require() chunk loading for javascript
__webpack_require__.f.require = (chunkId, promises) => {
	// "1" is the signal for "already loaded"
	if(!installedChunks[chunkId]) {
		if(true) { // all chunks have JS
			installChunk(require("./" + __webpack_require__.u(chunkId)));
		} else installedChunks[chunkId] = 1;
	}
};

// no external install chunk

// no HMR

// no HMR manifest